(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gpfs-batch-invoice', {
            parent: 'entity',
            url: '/gpfs-batch-invoice?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.gpfsBatchInvoice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gpfs-batch-invoice/gpfs-batch-invoices.html',
                    controller: 'GpfsBatchInvoiceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gpfsBatchInvoice');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('gpfs-batch-invoice-detail', {
            parent: 'gpfs-batch-invoice',
            url: '/gpfs-batch-invoice/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.gpfsBatchInvoice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gpfs-batch-invoice/gpfs-batch-invoice-detail.html',
                    controller: 'GpfsBatchInvoiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gpfsBatchInvoice');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GpfsBatchInvoice', function($stateParams, GpfsBatchInvoice) {
                    return GpfsBatchInvoice.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'gpfs-batch-invoice',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('gpfs-batch-invoice-detail.edit', {
            parent: 'gpfs-batch-invoice-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gpfs-batch-invoice/gpfs-batch-invoice-dialog.html',
                    controller: 'GpfsBatchInvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GpfsBatchInvoice', function(GpfsBatchInvoice) {
                            return GpfsBatchInvoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gpfs-batch-invoice.new', {
            parent: 'gpfs-batch-invoice',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gpfs-batch-invoice/gpfs-batch-invoice-dialog.html',
                    controller: 'GpfsBatchInvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('gpfs-batch-invoice', null, { reload: 'gpfs-batch-invoice' });
                }, function() {
                    $state.go('gpfs-batch-invoice');
                });
            }]
        })
        .state('gpfs-batch-invoice.edit', {
            parent: 'gpfs-batch-invoice',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gpfs-batch-invoice/gpfs-batch-invoice-dialog.html',
                    controller: 'GpfsBatchInvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GpfsBatchInvoice', function(GpfsBatchInvoice) {
                            return GpfsBatchInvoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gpfs-batch-invoice', null, { reload: 'gpfs-batch-invoice' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gpfs-batch-invoice.delete', {
            parent: 'gpfs-batch-invoice',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gpfs-batch-invoice/gpfs-batch-invoice-delete-dialog.html',
                    controller: 'GpfsBatchInvoiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GpfsBatchInvoice', function(GpfsBatchInvoice) {
                            return GpfsBatchInvoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gpfs-batch-invoice', null, { reload: 'gpfs-batch-invoice' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
